import { createTheme, responsiveFontSizes } from '@mui/material/styles';

const theme = responsiveFontSizes(
  createTheme({
    palette: {
      primary: {
        main: '#0066FF',
      },
      secondary: {
        main: '#55c57a',
        light: '#7ed56f',
        dark: '#28b485',
      },
      grey: {
        100: '#f7f7f7',
        200: '#eee',
        500: '#777',
        700: '#999',
        900: '#333',
      },
      background: {
        default: '#fff',
      },
      text: {
        primary: '#333',
        secondary: '#777',
      },
    },
    typography: {
      htmlFontSize: 10,
      fontFamily: ['"Franklin Gothic Pro"', 'Arial', 'sans-serif'].join(','),
      button: {
        textTransform: 'none',
      },
    },
    spacing: 8,
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: 4,
          },
        },
      },
      MuiCssBaseline: {
        styleOverrides: {
          html: {
            fontSize: '62.5%',
          },
        },
      },
    },
  })
);

export default theme;
